// removed by extract-text-webpack-plugin
module.exports = {"SocialHandle":"SocialHandle---29BSi","SocialHandle__Input":"SocialHandle__Input---2uRaD","SocialHandle__URL":"SocialHandle__URL---1Y5LF","SocialHandle__InputContainer":"SocialHandle__InputContainer---3SDOe"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ContactInfo/styles.styl
// module id = e37Q
// module chunks = 89